"use client";

import { c as _c } from "react/compiler-runtime";
import photo_image from "./changwei_at_google_taipei.jpg";
import { Now } from "./Now";
import { OutsideLink } from "@/components/OutsideLink";
import { CameraOutlined, ClockCircleOutlined, EnvironmentOutlined, MailOutlined } from "@ant-design/icons";
import { Divider, Space, Tag } from "antd";
import NextImage from "next/image";
import { useTranslations } from "next-intl";
import React from "react";
import styles from "./ProfileSection.module.sass";
function getProfileRows(t: (key: string) => string) {
  return [{
    rowKey: "birthday",
    label: t("birthday"),
    value: t("birthdayValue")
  }, {
    rowKey: "location",
    label: t("location"),
    value: <OutsideLink href="https://www.google.com/maps/place/Da%E2%80%99an+District,+Taipei+City,+106/@25.026306,121.5232035,14z/data=!3m1!4b1!4m6!3m5!1s0x3442aa2c1969f84d:0x6ea0b5cbf2d9955d!8m2!3d25.0249441!4d121.5433783!16zL20vMDJfNDY3?entry=ttu">
          {t("locationValue")}
        </OutsideLink>
  }, {
    rowKey: "homeplace",
    label: t("homeplace"),
    value: <OutsideLink href="https://map.baidu.com/search/%E5%90%89%E5%B7%9E%E5%8C%BA/@12789893.52945679,3124670.185,12.7z?querytype=s&da_src=shareurl&wd=%E5%90%89%E5%B7%9E%E5%8C%BA&c=9002&src=0&wd2=%E5%90%89%E5%AE%89%E5%B8%82%E5%90%89%E5%B7%9E%E5%8C%BA&pn=0&sug=1&l=15&b=(13523606.739607658,2856687.76226769;13540382.739607658,2863967.76226769)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=fb92f2f75515957842afe6c6&device_ratio=1">
          {t("homeplaceValue")}
        </OutsideLink>
  }, {
    rowKey: "major",
    label: t("majorDegree"),
    value: <OutsideLink href="https://www.ace.ntnu.edu.tw/">
          {t("majorValue")}
        </OutsideLink>
  }, {
    rowKey: "school",
    label: t("school"),
    value: <OutsideLink href="https://www.ntnu.edu.tw/">
          {t("schoolValue")}
        </OutsideLink>
  }, {
    rowKey: "timezone",
    label: t("timezone"),
    value: <>
          <OutsideLink href="https://timezonedb.com/time-zones/Asia/Taipei">
            Asia/Taipei (UTC+08:00)
          </OutsideLink>
          , <Now />
        </>
  }, {
    rowKey: "language",
    label: t("language"),
    value: <Space orientation={"vertical"}>
          <div>
            <Tag>zh-Hans-CN</Tag>
            <span>{t("langHans")}</span>
          </div>
          <div>
            <Tag>zh-Hant-TW</Tag>
            <span>{t("langHant")}</span>
          </div>
          <div>
            <Tag>en</Tag>
            <span>{t("langEnLabel")}</span>
          </div>
        </Space>
  }];
}
function PhotoPlaceValue(t0) {
  const $ = _c(14);
  const {
    t
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t) {
    const parts = t("photoPlaceLines").split(" | ").map(_temp);
    T0 = OutsideLink;
    t1 = "https://www.google.com/maps/place/Google+Taipei/@25.0339808,121.561964,17z/data=!3m1!4b1!4m6!3m5!1s0x3442abb6da80a7ad:0xdfbc764cc6880ac8!8m2!3d25.033976!4d121.5645389!16s%2Fg%2F12ll42d15?entry=ttu";
    t2 = "OutsideLink";
    t3 = "PhotoPlaceValue";
    t4 = "ProfileSection.tsx";
    t5 = parts.map(_temp2);
    $[0] = t;
    $[1] = T0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    T0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <T0 href={t1} data-sentry-element={t2} data-sentry-component={t3} data-sentry-source-file={t4}>{t5}</T0>;
    $[7] = T0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp2(line, i) {
  return <React.Fragment key={i}>{i > 0 ? <br /> : null}{line}</React.Fragment>;
}
function _temp(s) {
  return s.trim();
}
function PhotoExifValue(t0) {
  const $ = _c(4);
  const {
    t
  } = t0;
  let t1;
  if ($[0] !== t) {
    const parts = t("photoExifValue").split(" | ").map(_temp3);
    t1 = parts.map(_temp4);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp4(line, i) {
  return <React.Fragment key={i}>{i > 0 ? <br /> : null}{line}</React.Fragment>;
}
function _temp3(s) {
  return s.trim();
}
export interface IPropsProfileSection {}
export const ProfileSection: React.FunctionComponent<IPropsProfileSection> = () => {
  const $ = _c(132);
  const t = useTranslations("profile");
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== t) {
    const profile = getProfileRows(t);
    t5 = styles.profile;
    t6 = "ProfileSection";
    t7 = "ProfileSection.tsx";
    const t8 = t("trueName");
    let t9;
    if ($[9] !== t8) {
      t9 = <div className={styles.profile_info_name_key}>{t8}</div>;
      $[9] = t8;
      $[10] = t9;
    } else {
      t9 = $[10];
    }
    let t10;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className={styles.pronounce}>[tʃɑŋ weɪ]</div>;
      $[11] = t10;
    } else {
      t10 = $[11];
    }
    let t11;
    let t12;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div>{t10}<Space data-sentry-element="Space" data-sentry-source-file="ProfileSection.tsx"><strong>Chang, Wei</strong><Tag data-sentry-element="Tag" data-sentry-source-file="ProfileSection.tsx">en</Tag></Space></div>;
      t12 = <div className={styles.pronounce}>Chāng Wéi</div>;
      $[12] = t11;
      $[13] = t12;
    } else {
      t11 = $[12];
      t12 = $[13];
    }
    let t13;
    let t14;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <div>{t12}<Space data-sentry-element="Space" data-sentry-source-file="ProfileSection.tsx"><strong>昌维</strong><Tag data-sentry-element="Tag" data-sentry-source-file="ProfileSection.tsx">zh-Hans</Tag></Space></div>;
      t14 = <div className={styles.pronounce}>ㄔㄤ ㄨㄟˊ</div>;
      $[14] = t13;
      $[15] = t14;
    } else {
      t13 = $[14];
      t14 = $[15];
    }
    let t15;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <h1 className={styles.profile_info_name_value}><Space separator="/" wrap={true} data-sentry-element="Space" data-sentry-source-file="ProfileSection.tsx">{t11}{t13}<div>{t14}<Space data-sentry-element="Space" data-sentry-source-file="ProfileSection.tsx"><strong>昌維</strong><Tag data-sentry-element="Tag" data-sentry-source-file="ProfileSection.tsx">zh-Hant</Tag></Space></div></Space></h1>;
      $[16] = t15;
    } else {
      t15 = $[16];
    }
    if ($[17] !== t9) {
      t4 = <Space className={styles.profile_info_name} wrap={true} data-sentry-element="Space" data-sentry-source-file="ProfileSection.tsx">{t9}{t15}</Space>;
      $[17] = t9;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    t2 = styles.profile_info_list;
    t3 = <tbody className={styles.profile_info_list_desktop}>{profile.map(_temp5)}</tbody>;
    t0 = styles.profile_info_list_mobile;
    t1 = profile.map(_temp6);
    $[0] = t;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[19] !== t0 || $[20] !== t1) {
    t8 = <tbody className={t0}>{t1}</tbody>;
    $[19] = t0;
    $[20] = t1;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t2 || $[23] !== t3 || $[24] !== t8) {
    t9 = <table className={t2}>{t3}{t8}</table>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Divider orientation="vertical" />;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <MailOutlined data-sentry-element="MailOutlined" data-sentry-source-file="ProfileSection.tsx" />;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t) {
    t12 = t("emailGlobal");
    $[28] = t;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12) {
    t13 = <span className={styles.profile_contact_list_item_key}>{t11} {t12}{" "}</span>;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className={styles.profile_contact_list_item_value}><a href="mailto:changwei1006@gmail.com">changwei1006@gmail.com</a></span>;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13) {
    t15 = <div>{t13}{t14}</div>;
    $[33] = t13;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <MailOutlined data-sentry-element="MailOutlined" data-sentry-source-file="ProfileSection.tsx" />;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t) {
    t17 = t("emailChina");
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17) {
    t18 = <span className={styles.profile_contact_list_item_key}>{t16} {t17}{" "}</span>;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <span className={styles.profile_contact_list_item_value}><a href="mailto:changwei1006@qq.com">changwei1006@qq.com</a></span>;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t18) {
    t20 = <div>{t18}{t19}</div>;
    $[41] = t18;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t15 || $[44] !== t20) {
    t21 = <div><Space className={styles.profile_contact_list} separator={t10} data-sentry-element="Space" data-sentry-source-file="ProfileSection.tsx">{t15}{t20}</Space></div>;
    $[43] = t15;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <EnvironmentOutlined data-sentry-element="EnvironmentOutlined" data-sentry-source-file="ProfileSection.tsx" />;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t) {
    t23 = t("addressEnLabel");
    $[47] = t;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t23) {
    t24 = <div className={styles.profile_location_list_item_key}>{t22} {t23}{" "}</div>;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t) {
    t25 = t("addressEnValue");
    $[51] = t;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t25) {
    t26 = <div className={styles.profile_location_list_item_value}><OutsideLink href="https://maps.app.goo.gl/nXxbx9iaARZxa5hEA" data-sentry-element="OutsideLink" data-sentry-source-file="ProfileSection.tsx">{t25}</OutsideLink></div>;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t24 || $[56] !== t26) {
    t27 = <div>{t24}{t26}</div>;
    $[55] = t24;
    $[56] = t26;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <EnvironmentOutlined data-sentry-element="EnvironmentOutlined" data-sentry-source-file="ProfileSection.tsx" />;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t) {
    t29 = t("addressZhLabel");
    $[59] = t;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  let t30;
  if ($[61] !== t29) {
    t30 = <div className={styles.profile_location_list_item_key}>{t28} {t29}{" "}</div>;
    $[61] = t29;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] !== t) {
    t31 = t("addressZhValue");
    $[63] = t;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] !== t31) {
    t32 = <div className={styles.profile_location_list_item_value}><OutsideLink href="https://maps.app.goo.gl/nXxbx9iaARZxa5hEA" data-sentry-element="OutsideLink" data-sentry-source-file="ProfileSection.tsx">{t31}</OutsideLink></div>;
    $[65] = t31;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== t30 || $[68] !== t32) {
    t33 = <div>{t30}{t32}</div>;
    $[67] = t30;
    $[68] = t32;
    $[69] = t33;
  } else {
    t33 = $[69];
  }
  let t34;
  if ($[70] !== t27 || $[71] !== t33) {
    t34 = <div className={styles.profile_location}><Space className={styles.profile_location_list} orientation="vertical" wrap={true} data-sentry-element="Space" data-sentry-source-file="ProfileSection.tsx">{t27}{t33}</Space></div>;
    $[70] = t27;
    $[71] = t33;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] !== t21 || $[74] !== t34 || $[75] !== t4 || $[76] !== t9) {
    t35 = <div>{t4}{t9}{t21}{t34}</div>;
    $[73] = t21;
    $[74] = t34;
    $[75] = t4;
    $[76] = t9;
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  let t36;
  if ($[78] !== t) {
    t36 = t("photoAlt");
    $[78] = t;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] !== t36) {
    t37 = <NextImage className={styles.profile_photo_image} src={photo_image} alt={t36} width={photo_image.width} height={photo_image.height} sizes="(max-width: 768px) 100vw, 384px" priority={true} data-sentry-element="NextImage" data-sentry-source-file="ProfileSection.tsx" />;
    $[80] = t36;
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  let t38;
  if ($[82] !== t) {
    t38 = t("photoDescription");
    $[82] = t;
    $[83] = t38;
  } else {
    t38 = $[83];
  }
  let t39;
  if ($[84] !== t38) {
    t39 = <div className={styles.profile_photo_description}>{t38}</div>;
    $[84] = t38;
    $[85] = t39;
  } else {
    t39 = $[85];
  }
  let t40;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <ClockCircleOutlined data-sentry-element="ClockCircleOutlined" data-sentry-source-file="ProfileSection.tsx" />;
    $[86] = t40;
  } else {
    t40 = $[86];
  }
  let t41;
  if ($[87] !== t) {
    t41 = t("datetime");
    $[87] = t;
    $[88] = t41;
  } else {
    t41 = $[88];
  }
  let t42;
  if ($[89] !== t41) {
    t42 = <td className={styles.profile_photo_info_list_item_key}>{t40} {t41}</td>;
    $[89] = t41;
    $[90] = t42;
  } else {
    t42 = $[90];
  }
  let t43;
  if ($[91] !== t) {
    t43 = t("photoDatetimeValue");
    $[91] = t;
    $[92] = t43;
  } else {
    t43 = $[92];
  }
  let t44;
  if ($[93] !== t43) {
    t44 = <td className={styles.profile_photo_info_list_item_value}>{t43}</td>;
    $[93] = t43;
    $[94] = t44;
  } else {
    t44 = $[94];
  }
  let t45;
  if ($[95] !== t42 || $[96] !== t44) {
    t45 = <tr className={styles.profile_photo_info_list_item}>{t42}{t44}</tr>;
    $[95] = t42;
    $[96] = t44;
    $[97] = t45;
  } else {
    t45 = $[97];
  }
  let t46;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <EnvironmentOutlined data-sentry-element="EnvironmentOutlined" data-sentry-source-file="ProfileSection.tsx" />;
    $[98] = t46;
  } else {
    t46 = $[98];
  }
  let t47;
  if ($[99] !== t) {
    t47 = t("photoLocation");
    $[99] = t;
    $[100] = t47;
  } else {
    t47 = $[100];
  }
  let t48;
  if ($[101] !== t47) {
    t48 = <td className={styles.profile_photo_info_list_item_key}>{t46} {t47}</td>;
    $[101] = t47;
    $[102] = t48;
  } else {
    t48 = $[102];
  }
  let t49;
  if ($[103] !== t) {
    t49 = <td className={styles.profile_photo_info_list_item_value}><PhotoPlaceValue t={t} data-sentry-element="PhotoPlaceValue" data-sentry-source-file="ProfileSection.tsx" /></td>;
    $[103] = t;
    $[104] = t49;
  } else {
    t49 = $[104];
  }
  let t50;
  if ($[105] !== t48 || $[106] !== t49) {
    t50 = <tr className={styles.profile_photo_info_list_item}>{t48}{t49}</tr>;
    $[105] = t48;
    $[106] = t49;
    $[107] = t50;
  } else {
    t50 = $[107];
  }
  let t51;
  if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <CameraOutlined data-sentry-element="CameraOutlined" data-sentry-source-file="ProfileSection.tsx" />;
    $[108] = t51;
  } else {
    t51 = $[108];
  }
  let t52;
  if ($[109] !== t) {
    t52 = t("exif");
    $[109] = t;
    $[110] = t52;
  } else {
    t52 = $[110];
  }
  let t53;
  if ($[111] !== t52) {
    t53 = <td className={styles.profile_photo_info_list_item_key}>{t51} {t52}</td>;
    $[111] = t52;
    $[112] = t53;
  } else {
    t53 = $[112];
  }
  let t54;
  if ($[113] !== t) {
    t54 = <td className={styles.profile_photo_info_list_item_value}><PhotoExifValue t={t} data-sentry-element="PhotoExifValue" data-sentry-source-file="ProfileSection.tsx" /></td>;
    $[113] = t;
    $[114] = t54;
  } else {
    t54 = $[114];
  }
  let t55;
  if ($[115] !== t53 || $[116] !== t54) {
    t55 = <tr className={styles.profile_photo_info_list_item}>{t53}{t54}</tr>;
    $[115] = t53;
    $[116] = t54;
    $[117] = t55;
  } else {
    t55 = $[117];
  }
  let t56;
  if ($[118] !== t45 || $[119] !== t50 || $[120] !== t55) {
    t56 = <div className={styles.profile_photo_info}><table className={styles.profile_photo_info_list}><tbody>{t45}{t50}{t55}</tbody></table></div>;
    $[118] = t45;
    $[119] = t50;
    $[120] = t55;
    $[121] = t56;
  } else {
    t56 = $[121];
  }
  let t57;
  if ($[122] !== t37 || $[123] !== t39 || $[124] !== t56) {
    t57 = <div className={styles.profile_photo}>{t37}{t39}{t56}</div>;
    $[122] = t37;
    $[123] = t39;
    $[124] = t56;
    $[125] = t57;
  } else {
    t57 = $[125];
  }
  let t58;
  if ($[126] !== t35 || $[127] !== t5 || $[128] !== t57 || $[129] !== t6 || $[130] !== t7) {
    t58 = <div className={t5} data-sentry-component={t6} data-sentry-source-file={t7}>{t35}{t57}</div>;
    $[126] = t35;
    $[127] = t5;
    $[128] = t57;
    $[129] = t6;
    $[130] = t7;
    $[131] = t58;
  } else {
    t58 = $[131];
  }
  return t58;
};
function _temp5(item) {
  return <tr key={item.rowKey} className={styles.profile_info_list_desktop_item}><td className={styles.profile_info_list_desktop_item_key}>{item.label}:</td><td className={styles.profile_info_list_desktop_item_value}>{item.value}</td></tr>;
}
function _temp6(item_0) {
  return <React.Fragment key={item_0.rowKey}><tr className={styles.profile_info_list_mobile_item}><td className={styles.profile_info_list_mobile_item_key}>{item_0.label}:</td></tr><tr className={styles.profile_info_list_mobile_item}><td className={styles.profile_info_list_mobile_item_value}>{item_0.value}</td></tr></React.Fragment>;
}